export default __webpack_public_path__ + "static/franchise-2-92610a6b93bca6a15f87eb87b031a815.jpg";